<template>
  <div class="container" :style="{'background-image': 'url('+loginbg+')'}">
    <div class="forms-container">
      <div class="signin-signup">
        <form action="" class="sign-up-form">
          <h2 class="title">主播注册</h2>
          <div class="input-field">
            <i class="fa fa-share-alt"></i>
            <input type="text" v-model="registerUserForm.shareCode" placeholder="分享码">
          </div>
          <div class="input-field">
            <i class="fa fa-user"></i>
            <input type="text" v-model="registerUserForm.userName" placeholder="用户手机号">
          </div>
          <div class="input-field">
            <i class="fa fa-phone"></i>
            <div class="verify-input">
              <input type="text" v-model="registerUserForm.verifyCode" placeholder="验证码">
              <input id="verifyCode" type="button" @click="queryVerifyCode" value="获取验证码" class="code-input">
            </div>
          </div>
          <div class="input-field">
            <i class="fa fa-lock"></i>
            <input type="password" v-model="registerUserForm.userPassword" placeholder="密码">
          </div>
          <div class="input-field">
            <i class="fa fa-lock"></i>
            <input type="password" v-model="registerUserForm.conformPassword" placeholder="确认密码">
          </div>
          <!--<div class="input-field">
            <i class="fa fa-user"></i>
            <input type="text" v-model="registerUserForm.userPhone" placeholder="手机号">
          </div>
          <div class="input-field">
            <i class="fa fa-user"></i>
            <select v-model="registerUserForm.userType" style="max-width: 230px">
              <option v-for="item in userTypeSelectOpt" :key="item">{{ item }}</option>
            </select>
          </div>-->
          <!--<div class="input-field">
            <i class="fa fa-envelope"></i>
            <input type="text" placeholder="Email">
          </div>-->
          <div v-show="registerUserForm.errorVisible" style="color: #cccccc">
            {{ registerUserForm.errorMsg }}
          </div>
          <input type="button" @click="userRegister" value="注 册" class="btn solid">
          <div style="color: #04befe;font-size: 14px">
            <van-row :gutter="20" style="margin-top: 1%;">
              <van-col :span="24" :offset="10">
                <span >已经有账号,</span><el-button type="text" @click="goToLogin">立即登录</el-button>
              </van-col>
            </van-row>
          </div>
        </form>

      </div>
    </div>
    <van-dialog
        title="注册成功"
        v-model="registDialogVisible"
        width="30%"
        center>
      <span>注册成功， 请选择对应客户端登录</span>
      <span slot="footer" class="dialog-footer">
         <van-button @click="registDialogVisible = false">知道了</van-button>
      </span>
    </van-dialog>
  </div>

</template>

<script>
import {isStrEmpty, validatePhone} from "../lib/utils";
import {querySmsTime, registerUser, sendSmsGetCode} from "../api/system/sys_user";
import {Toast} from "vant";

export default {
name: "anchorRegister",
  data() {
    return {
      userTypeSelectOpt: [
        "业务员",
        "商家",
        "主播",
        "试客"
      ],
      registerUserForm: {
        userName: "",
        userPassword: "",
        conformPassword: "",
        userType: "",
        userPhone: "",
        errorMsg: "",
        errorVisible: false
      },
      timeCount: 300,
      registDialogVisible: false,
      loginbg: require('@/assets/img/bglogin.jpeg'),
      dialogVisible: false
    };
  },
  created() {
    this.registerUserForm.userType = this.userTypeSelectOpt[0];
  },
  mounted() {
    const container = document.querySelector(".container");

    container.classList.add("sign-up-mode");

    if (this.$route.query.sharecode != null) {
      this.registerUserForm.shareCode = this.$route.query.sharecode;
    }
    this.$forceUpdate();
    querySmsTime().then(res=>{
      if (res.success){
        this.timeCount = res.data;
      }
    });
  },
  methods: {
    queryVerifyCode(){
      if (this.registerUserForm.userName == null){
        this.registerUserForm.errorMsg = "请输入手机号！"
        this.registerUserForm.errorVisible = true;
      }
      let that = this;
      let t;
      sendSmsGetCode(this.registerUserForm.userName).then(res=>{
        if (res.success){
          Toast.success("短信发送成功");
          let timeCount1 = that.timeCount;
          let val = document.getElementById("verifyCode");
          t = setInterval(()=>{
            if (timeCount1 >  0){
              --timeCount1;
              val.value = timeCount1;
            }else{
              val.value = "获取验证码";
              clearInterval(t);
            }
          }, 1000);
        }
      }).catch(err => {
        Toast.fail(err.message);
        clearInterval(t);
      });
    },
    goToLogin(){
      this.$router.push({name:'login'});
    },
    userRegister() {
      let that = this;
      this.registerUserForm.userPhone = this.registerUserForm.userName;
      this.registerUserForm.userType = "主播";
      if (window.location.hostname == "zb.taoxibao.fit" ||window.location.pathname == "/author"){
        this.registerUserForm.roleCode = "anchor";
      }else{
        this.registerUserForm.roleCode = "customer";
      }
      validatePhone(this.registerUserForm.userName, function (val) {
        if (!val) {
          that.registerUserForm.errorMsg = "请输入正确手机号码";
          that.registerUserForm.errorVisible = true;
        }else{
          if (isStrEmpty(that.registerUserForm.userPassword)){
            that.registerUserForm.errorMsg = "密码不能为空！";
            that.registerUserForm.errorVisible = true;
          }else if (that.registerUserForm.userPassword !== that.registerUserForm.conformPassword) {
            that.registerUserForm.errorMsg = "两次输入的密码不一致！请重新输入";
            that.registerUserForm.errorVisible = true;
          } else {
            registerUser(that.registerUserForm).then(res => {
              //that.registDialogVisible = true;
              //that.loginForm.username = that.registerUserForm.userName;
              //that.loginForm.password = that.registerUserForm.userPassword;
              that.$router.push({name:'login'});
            }).catch(err => {
              that.registerUserForm.errorMsg = err.message;
              that.registerUserForm.errorVisible = true;
            });
          }
        }
      });
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/* google字体库 */
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.container::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  /*
  border-radius: 50%;
  background: linear-gradient(-45deg, #4481eb, #04befe);
  top: -10%;
  right: 48%;
  transform: translateY(-50%);
  */
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, .3);
  z-index: 4;
  transition: 1.8s ease-in-out;
}

.forms-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

}

.signin-signup {
  position: absolute;
  top: 50%;
  left: 75%;
  /* 作用是什么 */
  transform: translate(-50%, -50%);
  width: 50%;
  display: grid;
  grid-template-columns: 1fr;
  z-index: 6;
  transition: 1s 0.7s ease-in-out;
}

form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 5rem;
  overflow: hidden;
  /* 难点 */
  grid-column: 1 / 2;
  grid-row: 1 / 2;

  /* delay防止表单提前暴露 */
  transition: 0.2s 0.7s ease-in-out;
}

form.sign-in-form {
  z-index: 2;
}

form.sign-up-form {
  z-index: 1;
  opacity: 0;
}

.title {
  font-size: 2.2rem;
  color: #ffffff;
  margin-bottom: 10px;
}

.input-field {
  max-width: 300px;
  width: 100%;
  height: 55px;
  background-color: #f0f0f0;
  margin: 10px 0;
  border-radius: 55px;
  display: grid;
  grid-template-columns: 15% 85%;
  padding: 0 .4rem;
}

.verify-input{
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .code-input{
    font-size: 1rem;
    color: #44b1eb;
    position: relative;
    right: 25%;
    text-align: right;
  }
}

.input-field select {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #aaa;
}

.input-field i {
  text-align: center;
  line-height: 55px;
  color: #acacac;
  font-size: 1.1rem;
}

.input-field input {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
}

.input-field input::placeholder {
  color: #aaa;
  font-weight: 500;
}

.btn {
  width: 300px;
  height: 40px;
  border: none;
  outline: none;
  border-radius: 49px;
  cursor: pointer;
  background-color: #5995fd;
  color: #fff;
  /* 大写 */
  text-transform: uppercase;
  font-weight: 600;
  margin: 10 xp 0;
  /* 动画延迟 */
  transition: .5s;
}

.btn:hover {
  background-color: #4d84e2;
}

.social-text {
  padding: .7rem 0;
  font-size: 1rem;
}

.social-media {
  display: flex;
  justify-content: center;
}

.social-icon {
  height: 40px;
  width: 40px;
  border: 1px solid #333;
  margin: 0 0.45rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-size: 1.1rem;
  border-radius: 50%;
  transition: 0.3s;
}

.social-icon:hover {
  color: #4481eb;
  border-color: #44b1eb;
}

.panels-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: center;
  justify-content: center;
  z-index: 7;
}

.panel .content {
  color: #fff;
  transition: .9s .6s ease-in-out;
}

.panel h3 {
  font-weight: 600;
  line-height: 1;
  font-size: 1.5rem;
}

.panel p {
  font-size: 0.95rem;
  padding: 0.7rem 0;
}

.btn.transparent {
  margin: 0;
  background: none;
  border: 2px solid #fff;
  width: 130px;
  height: 41px;
  font-weight: 600;
  font-size: 0.8rem;
}

.left-panel {
  pointer-events: all;
  padding: 3rem 17% 2rem 12%;
}

.right-panel {
  pointer-events: none;
  padding: 3rem 12% 2rem 17%;
}

.image {
  width: 100%;
  transition: 1.1s .4s ease-in-out;
}

.right-panel .content, .right-panel .image {
  transform: translateX(800px);
}

.container.sign-up-mode:before {
  /* transform: translate(100%, -50%);
   right: 52%;

   */
}

.container.sign-up-mode .left-panel .image,
.container.sign-up-mode .left-panel .content {
  transform: translateX(-800px);
}

.container.sign-up-mode .right-panel .content,
.container.sign-up-mode .right-panel .image {
  transform: translateX(0px);
}

.container.sign-up-mode .left-panel {
  pointer-events: none;
}

.container.sign-up-mode .right-panel {
  pointer-events: all;
}

.container.sign-up-mode .signin-signup {
  /*left: 25%;*/
}

.container.sign-up-mode form.sign-in-form {
  z-index: 1;
  opacity: 0;
}

.container.sign-up-mode form.sign-up-form {
  z-index: 2;
  opacity: 1;
}

@media(max-width: 870px) {
  .container {
    min-height: 800px;
    min-height: 100vh;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .container:before {
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  .signin-signup {
    width: 100%;
  }

  .panels-container {

    z-index: 10;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr 1fr;
  }

  .panel {
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 2.5rem 8%;
  }

  .verify-input{
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .code-input{
      font-size: 1rem;
      color: #44b1eb;
      position: relative;
      right: 30%;
      text-align: right;
    }
  }

  .image {
    width: 200px;
    transition: 0.9s 0.6s ease-in-out;
  }

  .left-panel {
    grid-row: 1 / 2;
  }

  .right-panel {
    grid-row: 3 / 4;
  }

  .panel h3 {
    font-size: 1.2rem;
  }

  .panel p {
    font-size: 0.7rem;
    padding: 0.5rem 0;
  }

  .btn.btn.transparent {
    width: 110px;
    height: 35px;
    font-variation-settings: 0.7rem;
  }

  .panel .content {
    padding-right: 15%;
    transition: 0.9s 0.8s ease-in-out;
  }

  .right-panel .content, .right-panel .image {
    transform: translateY(300px);
  }

  .container.sign-up-mode:before {
    transform: translate(-50%, 100%);
    bottom: 32%;
    right: initial;
  }

  .container.sign-up-mode .left-panel .image,
  .container.sign-up-mode .left-panel .content {
    transform: translateY(-300px);
  }

  .container.sign-up-mode .signin-signup {
    top: 5%;
    transform: translate(-50%, 0);
    left: 50%;
  }
}

@media (max-width: 465px) {
  form {
    padding: 0 1.5rem;
  }

  .image {
    display: none;
  }

  .container .left-panel .content,
  .container .right-panel .content {
    margin-left: 40px;
  }

}
</style>
